import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CustomMatPaginatorIntlService extends MatPaginatorIntl {
  constructor(private translate: TranslateService) {
    super();
    this.translate.onLangChange.subscribe(() => {
      this.updateTranslations();
    });
    this.updateTranslations();
  }

  updateTranslations(): void {
    const lang = localStorage.getItem('lang') || 'en-US';

    const dictItemsPerPage: Record<string, string> = {
      'en-US': 'Items per page:',
      'hi-IN': 'आइटम्स पर पेज:',
      'mr-IN': 'आयटम्स पर पेज:',
      'bn-IN': 'আইটেমস পার পেজ:'
    };

    const dictNextPage: Record<string, string> = {
      'en-US': 'Next page',
      'hi-IN': 'नेक्स्ट पेज',
      'mr-IN': 'नेक्स्ट पेज',
      'bn-IN': 'নেক্সট পেজ'
    };

    const dictPreviousPage: Record<string, string> = {
      'en-US': 'Previous page',
      'hi-IN': 'प्रीवियस पेज',
      'mr-IN': 'प्रीवियस पेज',
      'bn-IN': 'প্রিভিয়াস পেজ'
    };

    const dictFirstPage: Record<string, string> = {
      'en-US': 'First page',
      'hi-IN': 'फर्स्ट पेज',
      'mr-IN': 'फर्स्ट पेज',
      'bn-IN': 'ফার্স্ট পেজ'
    };

    const dictLastPage: Record<string, string> = {
      'en-US': 'Last page',
      'hi-IN': 'लास्ट पेज',
      'mr-IN': 'लास्ट पेज',
      'bn-IN': 'লাস্ট পেজ'
    };

    this.itemsPerPageLabel = dictItemsPerPage[lang] || 'Items per page:';
    this.nextPageLabel = dictNextPage[lang] || 'Next page';
    this.previousPageLabel = dictPreviousPage[lang] || 'Previous page';
    this.firstPageLabel = dictFirstPage[lang] || 'First page';
    this.lastPageLabel = dictLastPage[lang] || 'Last page';
    this.changes.next();
  }

  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    const lang = localStorage.getItem('lang') || 'en-US';
    const dictOf: Record<string, string> = {
      'en-US': 'of',
      'hi-IN': 'ऑफ',
      'mr-IN': 'ऑफ',
      'bn-IN': 'অফ'
    };
    const ofText = dictOf[lang] || 'of';

    if (length === 0 || pageSize === 0) {
      return `0 ${ofText} ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

    return `${startIndex + 1} - ${endIndex} ${ofText} ${length}`;
  };
}
